








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsPartsArticle extends Vue {
  @Prop({ type: String, default: '' })
  name: string;

  @Prop({ type: String, default: '' })
  article: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/article/Article.vue